export default __webpack_public_path__ + "static/media/sublevel1_4.64199b12.webp";